import React, { useState } from 'react'
import { Box, Typography } from '@mui/material'
import PersonIcon from '@mui/icons-material/Person'
import StarIcon from '@mui/icons-material/Star'
import HomeIcon from '@mui/icons-material/Home'
import EventIcon from '@mui/icons-material/Event'
import { useNavigate, useLocation } from 'react-router-dom'

const tabs = [
  { path: '/profile', label: 'Profile', Icon: PersonIcon },
  { path: '/favorites', label: 'Favorites', Icon: StarIcon },
  { path: '/posts', label: 'Explore', Icon: HomeIcon },
  { path: '/appointments', label: 'Appointments', Icon: EventIcon },
]

const BottomNavBar = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const currentTab = tabs.findIndex(t => location.pathname.startsWith(t.path))
  const [value, setValue] = useState(currentTab === -1 ? 2 : currentTab)

  return (
    <Box
      sx={{
        position: 'fixed',
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 1200,
        bgcolor: 'background.paper',
        boxShadow: '0 -1px 0 rgba(0,0,0,0.07), 0 -4px 20px rgba(0,0,0,0.06)',
        // Extra height + bottom padding reserve room for the home indicator
        // on real devices without shrinking the actual 64px tab-bar content
        // (box-sizing: border-box via CssBaseline keeps the math exact).
        height: 'calc(64px + env(safe-area-inset-bottom, 0px))',
        pb: 'env(safe-area-inset-bottom, 0px)',
        display: 'flex',
        alignItems: 'center',
        px: 0.5,
      }}
    >
      {tabs.map(({ path, label, Icon }, index) => {
        const isActive = value === index
        return (
          <Box
            key={path}
            onClick={() => { setValue(index); navigate(path) }}
            sx={{
              flex: 1,
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
              gap: '3px',
              WebkitTapHighlightColor: 'transparent',
              userSelect: 'none',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: 44,
                height: 26,
                borderRadius: 20,
                bgcolor: isActive ? 'primary.main' : 'transparent',
                transition: 'background-color 0.22s ease',
              }}
            >
              <Icon
                sx={{
                  fontSize: 19,
                  color: isActive ? '#fff' : 'text.secondary',
                  transition: 'color 0.22s ease',
                }}
              />
            </Box>
            <Typography
              sx={{
                fontSize: '0.6rem',
                fontWeight: isActive ? 700 : 400,
                color: isActive ? 'primary.main' : 'text.secondary',
                lineHeight: 1,
                transition: 'color 0.22s ease, font-weight 0.22s ease',
                letterSpacing: 0,
              }}
            >
              {label}
            </Typography>
          </Box>
        )
      })}
    </Box>
  )
}

export default BottomNavBar
